import { useEffect, useState } from "react";
import { Wheel } from "react-custom-roulette";
import { CURRENT_ENV } from "../../Utills/constants";
import axios from "axios";
import liff from "@line/liff";
import LoadingScreen from "../Loading/LoadingScreen";

function Theme5Screen() {
  const [profileLine, setProfileLine] = useState();

  const [listRewards, setListRewards] = useState(null);
  const [rewards, setRewards] = useState(null);
  const [isSpinning, setIsSpinning] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    liff
      .init({
        liffId: CURRENT_ENV.LIFF_ID5,
      })
      .then(async () => {
        if (liff.isLoggedIn()) {
          liff
            .getProfile()
            .then((profile) => {
              console.log("%cPROFILE LINEOA : ", "color: green", profile);
              setProfileLine(profile.userId);
            })
            .catch((err) => {
              console.log("%cERROR LINEOA DETAIL", "color: red", err);
            });
        } else {
          liff.login();
        }
      })
      .catch((err) => {
        console.log(
          "%cERROR LINEOA HEADER",
          "color: red",
          err.code,
          err.message
        );
      });
    return () => { };
  }, []);

  useEffect(() => {
    const fetchRewards = async () => {
      try {
        const response = await axios.get(`${CURRENT_ENV.API_BASE_URL5}?path=getRewards`);
        if (response.data.status === 200) {

          setListRewards(response.data.data)
        }
      } catch (_) { }
      finally {
        // setLoading(false)
      }
    };
    fetchRewards();

  }, []);

  useEffect(() => {
    const fetchData = async () => {

      if (profileLine) {
        try {
          const response = await axios.get(`${CURRENT_ENV.API_BASE_URL5}?path=getData&userId=${profileLine}`);
          if (response.data.status === 200) {
            setData(response.data.data)
          }
        } catch (_) { }
        finally {
          setLoading(false)
        }
      }
    };
    fetchData();

  }, [profileLine]);

  // 🎰 ฟังก์ชันสุ่มรางวัลตาม % (weighted random)
  const getRandomRewardIndex = (rewards) => {
    const total = rewards.reduce((sum, item) => sum + item.percent, 0);
    const random = Math.random() * total;
    let cumulative = 0;

    for (let i = 0; i < rewards.length; i++) {
      cumulative += rewards[i].percent;
      if (random <= cumulative) return i;
    }
    return rewards.length - 1;
  };

  const randomRewards = async () => {
    if (isSpinning) return;

    setRewards(null);
    setIsSpinning(true);

    // ✅ สุ่มตาม % ที่กำหนด
    const randomIndex = getRandomRewardIndex(listRewards);
    setPrizeNumber(randomIndex);

    setTimeout(async () => {
      setIsSpinning(false);
      try {
        setLoading(true)

        const response = await axios.get(`${CURRENT_ENV.API_BASE_URL5}?path=play2&userId=${profileLine}&reward=${listRewards[randomIndex].name}`);

        if (response.data?.status === 200) {
          setData(response.data.data)
          setRewards(listRewards[randomIndex]);
          // setRewards(response.data)
          liff
            .sendMessages([
              {
                "type": "flex",
                "altText": `ยินดีด้วยคุณได้รับรางวัล คลิกเพื่อดู`,
                "contents": {
                  "type": "bubble",
                  "hero": {
                    "type": "image",
                    "url": CURRENT_ENV.FLEX_IMAGE5,
                    "size": "full",
                    "aspectRatio": "20:13",
                    "aspectMode": "cover"
                  },
                  "body": {
                    "type": "box",
                    "layout": "vertical",
                    "contents": [
                      {
                        "type": "text",
                        "text": "แทนคำขอบคุณในเดือนมีนาคม",
                        "weight": "bold",
                        "size": "xl"
                      },
                      {
                        "type": "box",
                        "layout": "vertical",
                        "contents": [
                          {
                            "type": "text",
                            "text": `ยินดีด้วยคุณได้รับ ${listRewards[randomIndex].name}`,
                            "size": "lg",
                            "color": "#B3B3B3",
                            "wrap": true
                          }
                        ]
                      }
                    ]
                  }
                }
              }
            ])
            .then(() => {
              window.alert("ส่งรางวัลไปยังช่องแชทเรียบร้อยค่ะ")
            })
            .catch((err) => {
              console.log("error", err);
            });
        } else if (response.data.status === 204) {
          window.alert(response.data.message)
        }
      } catch (_) { }
      finally {
        setLoading(false)
      }
    }, 6000);
  };

  return (
    <>
      {
        loading ?
          <LoadingScreen />
          : null
      }

      <div className="container app-bg" style={{ textAlign: "center", }}>
        <h1 className="txt-title">🎡 วงล้อเสี่ยงโชค</h1>

        <div style={{ marginTop: -10 }}>
          {listRewards ? (
            <Wheel
              mustStartSpinning={isSpinning}
              prizeNumber={prizeNumber}
              data={listRewards.map((r) => ({ option: `${r.name}` }))}
              backgroundColors={[
                "#ffffff", // white
                "#f5a3a3", // pastel red
                "#b6d7a8", // pastel green
                "#b9c5f8", // pastel blue/purple
                "#f6c58f", // pastel orange
                "#e5a8d6", // pastel pink/purple
                "#f4e88a"  // pastel yellow
              ]}
              textColors={["#333"]}
              fontSize={16}
              outerBorderWidth={2}
              radiusLineWidth={1}
              spinDuration={0.5}
              fontFamily="Kanit, sans-serif"
              style={{ width: "100%", height: "100%" }}
            />
          ) : (
            <p>⏳ กำลังโหลดของรางวัล...</p>
          )}

          {
            listRewards && (data?.value < data?.total || rewards?.data?.value < rewards?.data?.total) ?
              <button
                onClick={randomRewards}
                disabled={isSpinning}
                style={{
                  margin: 10,
                  padding: "5px 30px",
                  fontSize: 18,
                  borderRadius: 15,
                  backgroundColor: "#FFDD00",
                  cursor: "pointer",
                  border: "1px solid #000000",
                }}
              >
                {isSpinning ? "กำลังหมุน..." : "หมุนวงล้อ"}
              </button>
              : null
          }
        </div>

        {
          rewards ?
            <div>
              <div style={{ display: `flex`, flexDirection: `row`, backgroundColor: `#ffffff94`, borderRadius: 20, justifyContent: `center`, alignContent: `center`, overflow: `scroll`, padding: 10, fontSize: 18, fontWeight: `bold`, border: `3px solid #9bff15`, margin: 10 }}>
                คุณได้รับ : {rewards?.name}
              </div>
            </div>
            : null
        }

        {
          data?.value >= data?.total ?
            <div>
              <div style={{ display: `flex`, flexDirection: `row`, backgroundColor: `#ffffff94`, borderRadius: 20, justifyContent: `center`, alignContent: `center`, overflow: `scroll`, padding: 10, fontSize: 20, fontWeight: `bold`, border: `3px solid red`, margin: 10 }}>
                ขออภัย คุณใช้สิทธิ์สุ่มรางวัลครบแล้ว!
              </div>
            </div>
            : null
        }

        {
          listRewards ?
            <div style={{ marginTop: 10 }}>

              <div style={{ display: `flex`, justifyContent: `center`, padding: `0px 10px 10px 10px`, overflow: `scroll`, height: 200 }}>
                <div style={{ display: `grid`, width: `100%` }}>
                  <div className="grid-container">
                    {
                      listRewards?.map((data, index) => (
                        <div key={index}>
                          <div style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, flexDirection: `column`, margin: 1, fontSize: 12 }}>
                            <img src={data.image} alt="" style={{ width: 30 }} />
                            <div>
                              {data.name}
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div> : null
        }
      </div>
    </>

  );
}

export default Theme5Screen;
